import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    componentWillMount() {
        this.setState({ isOpen: false });
        this.props.requireState();
    }

    render({logged_in}) {
        if (this.props.links) {
            const links = this.props.links.map(link => (
                link.logged_in && logged_in ? link.logged_in : link
            ));

            return (
                <desktop-nav-dropdown>
                    <span onClick={this.toggle} class={`desktop-nav-dropdown ${this.state.isOpen ? 'active' : ''}`}>
                        More For Today
                    </span>
                    {links.map(this.renderLink)}
                </desktop-nav-dropdown>
            );
        }

        return null;
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    renderLink = ({label, url}) => {
        if (this.state.isOpen) {
            const impression_label = this.props.page_name ? `${this.props.page_name}:${label}` : label;
            this.trackImpression(impression_label);

            return (
                <div class='desktop-nav-dropdown'>
                    <a href={url} onClick={() => this.trackClick(label)}>
                        {label}
                    </a>
                </div>
            );
        }

        return null;
    }

    trackImpression = (label) => {
        this.props.trackEvent([ 'Dropdown', `${this.props.logged_in ? 'LI' : 'LO'} Impression`, label ]);
    }

    trackClick = (label) => {
        const click_label = this.props.page_name ? `${this.props.page_name}:${label}` : label;
        this.props.trackEvent([ 'Dropdown', `${this.props.logged_in ? 'LI' : 'LO'} Click`, click_label ]);
        this.props.trackPromo([ 'Dropdown', label ]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    links: state['mobile-nav-dropdown'],
});

const mapDispatchToProps = (dispatch) => ({
    requireState: () => dispatch({ type: 'mobile-nav-dropdown:init'}),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/responsive/desktop-nav-dropdown.js